import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { useStorage } from '~Components/Storage';

import NumberInput from '~ComponentsImproved/Numpad';
import { useI18n } from '~Hooks';
import { MethodProps } from '../types';

const PrintedInvoice: React.FunctionComponent<MethodProps> = ({ onComplete, payment, onFail }) => {
  const [{ enableTipping }] = useStorage();
  const [showTipModal, setShowTipModal] = useState(!payment.disableTip && enableTipping);
  const { i18n } = useI18n();

  if (showTipModal) {
    return (
      <NumberInput
        key="tip"
        initialValue={'0'}
        decimal
        title={i18n('TM.Tip')}
        onSubmit={(tipAmount) => {
          setShowTipModal(false);

          // Ensure input is valid
          const num = parseFloat(tipAmount);
          if (isNaN(num)) {
            onFail();
            return;
          }

          // Complete payment with added tip after a slight delay
          setTimeout(() => onComplete(undefined, { tip: num * 100, transactionId: uuid() }), 2000);
        }}
        onClose={() => {
          setShowTipModal(false);
          onFail(i18n('Payment.Canceled'));
        }}
      />
    );
  } else {
    // Complete payment without tip
    setTimeout(() => onComplete(undefined, { transactionId: uuid() }), 2000);
  }

  return null;
};

export default PrintedInvoice;
